// Legacy alias for external @core/journeys/ui/transformer imports —
// the canonical home is ../block.
export { transformer } from '../block/transformer'
